import { useEffect, useState } from 'react';
import { createClient } from 'contentful';

const client = createClient({
    environment: 'master',
    space: process.env.GATSBY_CONTENTFUL_SPACE,
    accessToken: process.env.GATSBY_CONTENTFUL_ACCESS_TOKEN,
});

function ContentfulBlogPosts() {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        client.getEntries({
            content_type: 'blogPosts',
            'fields.postListedOn': 'Spain',
            order: '-fields.postDate',
        })
        .then((response) => {
            setPosts(response.items);
        })
        .catch(console.error);
    }, []);

    return posts;
}

export default ContentfulBlogPosts;
